import {Component} from '@angular/core';
import {RouterLink} from '@angular/router';
import {MatButton} from '@angular/material/button';
import {VulcanIconComponent} from '@eagle-i/vulcan-component-library';
import {PageHeaderComponent} from '../../../shared/components/page-templates/page-header/page-header.component';
import {PageFooterComponent} from '../../../shared/components/page-templates/page-footer/page-footer.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

interface QuickStartLink {
  type: 'map' | 'report',
  title: string,
  description: string,
  link: string
}

@Component({
  selector: 'tgrid-new-landing',
  imports: [
    RouterLink,
    MatButton,
    VulcanIconComponent,
    PageHeaderComponent,
    PageFooterComponent,
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
  templateUrl: './new-landing.component.html',
  standalone: true,
  styleUrl: './new-landing.component.scss',
})
export class NewLandingComponent  {

  protected mapLayers: QuickStartLink[] = [
    {
      type: 'map',
      link: 'map',
      title: 'Outage Event Count',
      description: 'Displays the number of long-duration outages experienced by customers, recorded at the county level. The default, changeable by the user, displays the number of outages that took >12 hours to achieve ≥ 80% restoration.',
    },
    {
      type: 'map',
      link: 'map',
      title: 'Restoration Metrics',
      description: 'Evaluates resilience of the electric system due to extreme events via various metrics including the number of customers impacted, recovery duration time, and the area under the power outage curve.',
    },
    {
      type: 'map',
      link: 'map',
      title: 'Customer Coverage',
      description: 'Displays the estimated percentage of customer meters within a utility\'s service area whose outage status can be obtained by DOE via public websites. Select a county for details. This data is also listed in the Coverage Report.',
    },
    // {
    //   type: 'map',
    //   link: 'map',
    //   title: 'Disadvantaged',
    //   description: 'Census tracts designated as overburdened and underserved by the Climate & Economic Justice Screening Tool (CEJST) are highlighted as disadvantaged.'
    // },
  ];

  protected reports: QuickStartLink[] = [
    // {
    //   type: 'report',
    //   link: 'reports/weather-baseline',
    //   title: 'Weather Baseline Report',
    //   description: ''
    // },
    {
      type: 'report',
      link: 'reports/restoration-curve',
      title: 'Restoration Curve Report',
      description: 'This report displays the start/end times, peak time (first occurrence of maximum outage), number of customers impacted, and the area under the curve for extreme events. Select a row to populate the curve. The curve shows the progress of restoration from the peak outage (how long it takes to restore 20%, 40%, 60%, 80%, and 100% of customers after the power outage).',
    },
    {
      type: 'report',
      link: 'reports/county-coverage',
      title: 'Coverage Report',
      description: 'This report displays the most recent full calendar year coverage for a selected state. Coverage is defined as the number of customers for which EAGLE-I™ is collecting outage data for compared to the total customers in that area.',

    },
  ];

}
